import classNames from 'classnames';
import * as React from 'react';

import css from './Tag.module.scss';

interface Props extends React.HTMLProps<{}> {
  color: TagColor;
}

export enum TagColor {
  Default = 'default',
  Station = 'station', // deprecated
  Gray = 'gray',
}

class Tag extends React.PureComponent<Props> {
  public static defaultProps: Props = {
    color: TagColor.Default,
  };

  public render() {
    const classes = classNames(
      css.Tag,
      {
        [css.isGray]: this.props.color === TagColor.Station,
      },
      {
        [css.isGray]: this.props.color === TagColor.Gray,
      },
      this.props.className,
    );

    return <span className={classes}>{this.props.children}</span>;
  }
}

export default Tag;
